module.exports = __webpack_public_path__ + "img/EUflag.2bbe64ed.png";